<template>
  <Ribbon bg="gray-7">
    <div
      class="max-w-7xl mx-auto flex flex-col sm:flex-row sm:items-start sm:justify-center"
    >
      <div class="text-center">
        <TypeBody
          :variant="$options.Typography.Body.LARGE"
          :weight="$options.Typography.Weights.STRONG"
          tag="p"
          class="mb-8"
        >
          {{ headline }}
        </TypeBody>
        <TypeDisplay
          :variant="$options.Typography.Display.MEGA"
          :weight="$options.Typography.Weights.REGULAR"
          tag="p"
          class="leading-6 mb-8"
        >
          {{ tagline }}
        </TypeDisplay>
        <BaseButton variant="secondary" @click="$router.push(path)">{{
          cta
        }}</BaseButton>
      </div>
    </div>
  </Ribbon>
</template>

<script>
import { BaseButton, constants, TypeBody, TypeDisplay } from '@bambeehr/pollen';
import Ribbon from './HomeRibbon';

const { Typography } = constants;
export default {
  name: 'RibbonCTA',
  Typography,
  components: {
    BaseButton,
    Ribbon,
    TypeBody,
    TypeDisplay,
  },
  props: {
    headline: {
      type: String,
      default: 'Prices starting at $9/month',
    },
    tagline: {
      type: String,
      default: 'Ready to put your HR on autopilot?',
    },
    cta: {
      type: String,
      default: 'Try Bambee Now',
    },
    path: {
      type: String,
      default: '/registration/company-size',
    },
  },
  setup() {},
};
</script>
